import { useFeatureEnabled } from './useFeatureEnabled';

export function useFeatureClientOnboarding(): boolean {
  return useFeatureEnabled('CLIENT_ONBOARDING');
}
